import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { CartProductSuggestion } from '../../../core/models/cart.model';
import { CurrencyBRLPipe } from '../../pipes/currency-brl.pipe';
import { I18nPipe } from '../../pipes/i18n.pipe';
import { IconComponent } from '../icon/icon.component';
import { DEFAULT_DOMAIN_REGISTRATION_ICON } from '../../constants/domain-promo.constants';

@Component({
  selector: 'umkt-cart-product-suggestion',
  standalone: true,
  imports: [CommonModule, IconComponent, CurrencyBRLPipe, I18nPipe],
  templateUrl: './cart-product-suggestion.component.html',
  styleUrl: './cart-product-suggestion.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartProductSuggestionComponent {
  @Input({ required: true }) suggestion!: CartProductSuggestion;
  @Input() loading = false;

  @Output() accept = new EventEmitter<CartProductSuggestion>();
  @Output() dismiss = new EventEmitter<CartProductSuggestion>();

  readonly fallbackIcon = DEFAULT_DOMAIN_REGISTRATION_ICON;

  get icon() {
    return this.suggestion.icon ?? this.fallbackIcon;
  }

  onAccept(): void {
    if (this.loading) return;
    this.accept.emit(this.suggestion);
  }

  onDismiss(): void {
    if (this.loading) return;
    this.dismiss.emit(this.suggestion);
  }
}
